import { render, staticRenderFns } from "./BankAndProfileSideMenu.vue?vue&type=template&id=6c5e3f92&"
import script from "./BankAndProfileSideMenu.vue?vue&type=script&lang=js&"
export * from "./BankAndProfileSideMenu.vue?vue&type=script&lang=js&"
import style0 from "./BankAndProfileSideMenu.vue?vue&type=style&index=0&id=6c5e3f92&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VDivider,VProgressLinear,VRow})
